class YGProductVariantOptions extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    // Variant tabs
    
    const variantTabs = this.querySelectorAll(".yg-variant-tab");
    const variantWrappers = this.querySelectorAll(".yg-variant-wrapper");
    const mediaItems = this.querySelectorAll(
      ".product__media-wrapper.is-variant-group .product__media-item"
    );

    const $dom = this.querySelectorAll('.product-form__controls-group')
    const $filterdom = Array.from($dom).filter((item) => {
      return !item.classList.contains('yg-product-variant-group') && !item.classList.contains('yg-variant-progress-group')
    })
    
    $filterdom.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (e.target.tagName === 'LABEL') {
          const label = e.target
        const labelCopy = label.cloneNode(true);
        const spans = labelCopy.querySelectorAll('span');
        spans.forEach(span => span.remove());
        item.parentNode.querySelector('.product-form__group-name span').innerHTML = labelCopy.innerText
        }
      })
    })

    if (variantTabs.length > 0 && mediaItems.length > 0) {
      const firstTab = variantTabs[0];
      const firstVariantInfo = firstTab.getAttribute("data-variant-info");
      toggleMediaItems(firstVariantInfo);
    }

    if (variantTabs.length > 0) {
      variantTabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          setActiveTabAndWrapper(tab, index);
          const variantInfo = tab.getAttribute("data-variant-info");
          toggleMediaItems(variantInfo);
        });
      });
    }

    // 分组变体 - grid布局
    function toggleMediaItems(variantInfo) {
      let hasVisibleMedia = false;

      mediaItems.forEach((mediaItem) => {
        const mediaAltValue = mediaItem.getAttribute("data-media-alt");
        const mediaId = mediaAltValue ? mediaAltValue : null;

        if (mediaId === variantInfo) {
          mediaItem.classList.remove("hide");
          hasVisibleMedia = true;
        } else if (mediaId !== null) {
          mediaItem.classList.add("hide");
        }
      });

      if (!hasVisibleMedia) {
        mediaItems.forEach((mediaItem) => {
          const mediaAltValue = mediaItem.getAttribute("data-media-alt");
          const mediaId = mediaAltValue ? mediaAltValue : null;

          if (mediaId === null) {
            mediaItem.classList.remove("hide");
          }
        });
      }
    }

    function setActiveTabAndWrapper(tab, index) {
      variantTabs.forEach((item) => item.classList.remove("active"));
      variantWrappers.forEach((wrapper) => wrapper.classList.remove("active"));
      

      tab.classList.add("active");
      variantWrappers[index].classList.add("active");
      const activeWrapper = variantWrappers[index];
      const labels = activeWrapper.querySelectorAll("label");

      if (labels[0]) {
        labels[0].checked = true;
        labels[0].click();
      }
    }
  }
}

if (!window.customElements.get('yg-product-variant-options')) {
  window.customElements.define('yg-product-variant-options', YGProductVariantOptions)
}